import React, { useState, useRef } from "react";
import { AppBar, Toolbar, IconButton, Drawer, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, NavLink } from 'react-router-dom';
import { useTransition } from '../../context/TransitionContext.tsx';

const Navbar: React.FC = () => {
  const { navigateWithTransition } = useTransition();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    // Non navigare se siamo già sulla stessa pagina
    if (location.pathname === path) return;
    closeDrawer();
    navigateWithTransition(path);
  };

  const headerRef = useRef<HTMLElement | null>(null);

  return (
    <AppBar position="fixed" className="navbar header-fixed" ref={headerRef}>
      <Toolbar className="navbar__toolbar">
        {/* Logo Desktop */}
        <Box
          className="navbar__logo"
          sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}
        >
          <NavLink to="/" onClick={(e) => handleNavigation(e, '/')} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img
              src="/loghi/sito/logo.png"
              alt="Fabbri Agricoltura"
              style={{ height: '70px', width: 'auto' }}
            />
          </NavLink>
        </Box>

        {/* Logo Mobile */}
        <Box
          className="navbar__logo"
          sx={{ display: { xs: "flex", md: "none" }, alignItems: "center" }}
        >
          <NavLink to="/" onClick={(e) => handleNavigation(e, '/')} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img
              src="/loghi/sito/logo-m.png"
              alt="Fabbri Agricoltura"
              style={{ height: '60px', width: 'auto' }}
            />
          </NavLink>
        </Box>

        {/* Link Desktop */}
        <Box className="navbar__links" sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
          <NavLink
            to="/"
            onClick={(e) => handleNavigation(e, '/')}
            className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`}
            aria-label="Vai alla Home"
          >
            Home
          </NavLink>
          <NavLink
            to="/servizi"
            onClick={(e) => handleNavigation(e, '/servizi')}
            className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`}
            aria-label="Vai alla pagina Servizi"
          >
            Servizi
          </NavLink>
          <NavLink
            to="/prodotti"
            onClick={(e) => handleNavigation(e, '/prodotti')}
            className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`}
            aria-label="Vai alla pagina Prodotti"
          >
            Prodotti
          </NavLink>
          <NavLink
            to="/contatti"
            onClick={(e) => handleNavigation(e, '/contatti')}
            className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`}
            aria-label="Vai alla pagina Contatti"
          >
            Contatti
          </NavLink>
        </Box>

        {/* Menù burger per mobile */}
        <IconButton
          edge="start"
          onClick={() => setDrawerOpen(true)}
          sx={{ display: { xs: "flex", md: "none" }, color: '#1A1A1A' }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* Drawer (menu burger) */}
      <Drawer anchor="right" open={drawerOpen} onClose={closeDrawer} className="drawer_laterale">
        <Box sx={{ width: 280 }} role="presentation" className="burger-menu">
          <IconButton
            onClick={closeDrawer}
            className="burger-menu__close"
            aria-label="Chiudi menu"
          >
            <CloseIcon />
          </IconButton>
          <NavLink to="/" onClick={(e) => handleNavigation(e, '/')} aria-label="Vai alla Home">Home</NavLink>
          <NavLink to="/servizi" onClick={(e) => handleNavigation(e, '/servizi')} aria-label="Vai alla pagina Servizi">Servizi</NavLink>
          <NavLink to="/prodotti" onClick={(e) => handleNavigation(e, '/prodotti')} aria-label="Vai alla pagina Prodotti">Prodotti</NavLink>
          <NavLink to="/contatti" onClick={(e) => handleNavigation(e, '/contatti')} aria-label="Vai alla pagina Contatti">Contatti</NavLink>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
